import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { SALUTATION } from 'b2b-common/core/checkout/Checkout.types';
import { Props } from './FullName.types';

export const FullName = ({ className, ...address }: Props): ReactElement | null => {
  const t = useTranslate();
  const { salutation, firstName, lastName } = address;

  const getTitle = () => {
    switch (salutation) {
      case SALUTATION.male:
        return t('Mr.');

      case SALUTATION.female:
        return t('Ms.');

      case SALUTATION.company:
        return t('Company');

      default:
        return salutation;
    }
  };

  if (!salutation || !firstName || !lastName) {
    return null;
  }

  return (
    <div className={className} data-hj-suppress>
      {getTitle()} {firstName} {lastName}
    </div>
  );
};
